module.exports = __webpack_public_path__ + "img/merge-p1.c7479de3.jpg";